export var extractCommonProps = function extractCommonProps(props) {
  var common = {};
  var rest = {};

  for (var prop in props) {
    if (isCommonProp(prop)) {
      // @ts-expect-error: See: https://github.com/skbkontur/retail-ui/pull/2257#discussion_r565275843 and https://github.com/skbkontur/retail-ui/pull/2257#discussion_r569542736.
      common[prop] = props[prop];
    } else {
      // @ts-expect-error: Read the comment above.
      rest[prop] = props[prop];
    }
  }

  return [common, rest];
};

var isCommonProp = function isCommonProp(prop) {
  switch (true) {
    case prop === 'className':
    case prop === 'style':
    case prop === 'rootNodeRef':
    case prop === 'children':
    case prop.indexOf('data-') === 0:
      // все data-атрибуты
      return true;

    default:
      return false;
  }
};